import WCrossedOut from './crossed-out.vue';


export const components = {
  WCrossedOut
};

export function registerPreviewComponents(Vue, registerLog) {
  for (var name in components) {
    if (registerLog) {
      console.time('register ' + name);
      Vue.component(name, components[name]);
      console.timeEnd('register ' + name);
    } else {
      Vue.component(name, components[name]);
    }

  }
}


export default components;
